import { render, staticRenderFns } from "./vias.vue?vue&type=template&id=11d76b1e&scoped=true"
import script from "./vias.vue?vue&type=script&lang=js"
export * from "./vias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d76b1e",
  null
  
)

export default component.exports